import { PersonaConfig } from '../types';

export const hikingPersona: PersonaConfig = {
  id: 'hiking',
  name: 'Hiking & Climbing',
  icon: '🥾',
  description: 'Mountain weather, snow depth & snowline, lapse rates, sun intensity, and precip radar.',
  accentColor: '#10b981',
  timeline: {
    showSolarLunarTrack: true,
    showMoonPhaseBadges: true,
  },
  forecastPanel: {
    temperaturePlotMode: 'all',
    hideAstronomicalEvents: false,
    showMilkyWayArButton: false,
  },
  mapDefaults: {
    recommendedPrimaryLayer: undefined,
    enabledOverlays: [],
  },
};
